import { C4CSalesItemType, TourType } from '@api/index';

export const TOUR_SEARCH_QUERY_PARAM_KEYS = {
  date: 'date',
  slug: 'slug',
};

// Ölü `TourSelectionCard` bileşeni kaldırılırken buraya taşındı.
// (testing kontrat hizalaması — legacy tur yüzeyi temizliği)
export const TourTypesSalesItemMap: Record<TourType, C4CSalesItemType> = {
  [TourType.ABROAD]: C4CSalesItemType.TUR_YURT_DISI,
  [TourType.CRUISE]: C4CSalesItemType.TUR_CRUISE,
  [TourType.DOMESTIC_CULTURE]: C4CSalesItemType.TUR_KULTUR,
};
